import { INewFileUpload } from './new-file-upload';
import { IDocumentsVersion } from './documents-version';
import { IVersionedFile } from './versioned-file';

export interface ISrtrData {
    centerId: number,
    hasGraftSurvivalFile: boolean,
    dcAdultGraftSurvival1: number,
    dcAdultGraftSurvival3: number,
    dcPediatricGraftSurvival1: number,
    dcPediatricGraftSurvival3: number,
    adultGraftSurvival1: number,
    adultGraftSurvival3: number,
    pediatricGraftSurvival1: number,
    pediatricGraftSurvival3: number,
    dcAdultPatientSurvival1: number,
    dcAdultPatientSurvival3: number,
    dcPediatricPatientSurvival1: number,
    dcPediatricPatientSurvival3: number,
    adultPatientSurvival1: number,
    adultPatientSurvival3: number,
    pediatricPatientSurvival1: number,
    pediatricPatientSurvival3: number,

    graftSurvivalNewFile: INewFileUpload,

    graftSurvivalDocumentsVersions: IDocumentsVersion[],
    graftSurvivalVersionedFiles: IVersionedFile[],

    patientSurvivalNewFile: INewFileUpload,
    patientSurvivalDocumentsVersions: IDocumentsVersion[],

    patientSurvivalVersionedFiles: IVersionedFile[],
    
    srtrSourceDate: string,
    unosId: string
}
